(() => {
  const header = document.querySelector('[data-site-header]');
  const headerGroup = header?.closest('.shopify-section-group-header-group');
  if (!header || !headerGroup) return;

  const root = document.documentElement;
  const syncVisibleHeaderHeight = () => {
    root.style.setProperty('--gearonimo-header-height', `${header.getBoundingClientRect().height}px`);
  };
  syncVisibleHeaderHeight();
  const headerResizeObserver = new ResizeObserver(syncVisibleHeaderHeight);
  headerResizeObserver.observe(header);

  const compactQuery = window.matchMedia('(max-width: 990px)');
  let lastScrollY = Math.max(window.scrollY || 0, 0);
  let highScrollY = lastScrollY;
  let lowScrollY = lastScrollY;
  let direction = lastScrollY > 0 ? 'down' : 'up';
  let isCondensed = lastScrollY > 132;
  let ticking = false;

  const measureExpandedHeader = () => {
    const wasCondensed = header.classList.contains('is-condensed');
    const wasExpanded = header.classList.contains('is-expanded-on-scroll');

    header.classList.remove('is-condensed', 'is-expanded-on-scroll');
    const height = Math.ceil(header.getBoundingClientRect().height);
    if (height > 0) {
      root.style.setProperty('--gearonimo-header-offset', `${height}px`);
    }

    header.classList.toggle('is-condensed', wasCondensed);
    header.classList.toggle('is-expanded-on-scroll', wasExpanded);
  };

  const applyHeaderState = (currentScrollY) => {
    const isPastTop = currentScrollY > 18;
    const storeBanner = document.querySelector('.gearonimo-store-banner');
    if (storeBanner && !document.body.matches('.help-drawer-open, .cart-drawer-open, .condition-rating-drawer-open')) {
      storeBanner.classList.toggle('is-mobile-scroll', currentScrollY > 60);
    }
    header.classList.toggle('is-stuck', isPastTop);
    header.classList.toggle('is-condensed', isCondensed);
    header.classList.toggle('is-expanded-on-scroll', isPastTop && !isCondensed);
    header.dataset.scrollDirection = direction;
  };

  const syncHeader = () => {
    const currentScrollY = Math.max(window.scrollY || 0, 0);
    const delta = currentScrollY - lastScrollY;

    if (Math.abs(delta) > 2) {
      direction = delta > 0 ? 'down' : 'up';
    }

    const foldStart = compactQuery.matches ? 112 : 132;
    const foldDistance = compactQuery.matches ? 34 : 42;
    const revealDistance = compactQuery.matches ? 76 : 92;

    if (currentScrollY <= 28) {
      isCondensed = false;
      highScrollY = currentScrollY;
      lowScrollY = currentScrollY;
    } else if (isCondensed) {
      highScrollY = Math.max(highScrollY, currentScrollY);
      if (highScrollY - currentScrollY > revealDistance) {
        isCondensed = false;
        lowScrollY = currentScrollY;
      }
    } else {
      lowScrollY = Math.min(lowScrollY, currentScrollY);
      if (direction === 'down' && currentScrollY > foldStart && currentScrollY - lowScrollY > foldDistance) {
        isCondensed = true;
        highScrollY = currentScrollY;
      }
    }

    applyHeaderState(currentScrollY);
    lastScrollY = currentScrollY;
  };

  const requestHeaderSync = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      syncHeader();
      ticking = false;
    });
  };

  const handleResize = () => {
    measureExpandedHeader();
    requestHeaderSync();
  };

  measureExpandedHeader();
  syncHeader();
  window.addEventListener('scroll', requestHeaderSync, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });
  window.addEventListener('load', handleResize, { once: true });
  window.setTimeout(handleResize, 120);
})();

(() => {
  const initFeatureCarousels = (scope = document) => {
    scope.querySelectorAll('[data-feature-carousel]').forEach((carousel) => {
      if (carousel.dataset.featureCarouselReady === 'true') return;

      const viewport = carousel.querySelector('[data-feature-carousel-viewport]');
      const previous = carousel.querySelector('[data-feature-carousel-prev]');
      const next = carousel.querySelector('[data-feature-carousel-next]');
      const track = carousel.querySelector('.homepage-feature-carousel__track');
      const slides = Array.from(carousel.querySelectorAll('.homepage-feature-carousel__slide'));
      if (!viewport) return;

      carousel.dataset.featureCarouselReady = 'true';
      carousel.dataset.featureCarouselSlides = String(slides.length);
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayDelay = Number.parseInt(carousel.dataset.featureCarouselDelay || '4200', 10);
      const hoverAutoplayDelay = autoplayDelay * 2;
      const interactiveSelector = 'a, button, input, select, textarea, summary, [role="button"], [tabindex]:not([tabindex="-1"])';
      const motionCue = document.createElement('div');
      const dots = [];
      let autoplayTimer = null;
      let autoplayPaused = false;
      let carouselInView = true;
      let hoverActive = false;
      let activeIndex = 0;
      let nativeTouchActive = false;
      let touching = false;
      let touchSettleTimer = null;

      viewport.style.scrollBehavior = 'auto';
      if (!document.getElementById('gearonimo-feature-touch-stability')) {
        const style = document.createElement('style');
        style.id = 'gearonimo-feature-touch-stability';
        style.textContent = '@media (max-width: 990px), (pointer: coarse) { [data-feature-carousel] .homepage-feature-carousel__slide { transform: none !important; transition: opacity 280ms ease; } }';
        document.head.append(style);
      }

      motionCue.className = 'homepage-feature-carousel__motion';
      motionCue.setAttribute('aria-hidden', 'true');

      slides.forEach((slide, index) => {
        slide.dataset.featureCarouselSlideIndex = String(index);

        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'homepage-feature-carousel__dot';
        dot.setAttribute('aria-label', `Show feature slide ${index + 1}`);
        dot.setAttribute('tabindex', '-1');
        dot.innerHTML = '<span></span>';
        motionCue.append(dot);
        dots.push(dot);
      });

      if (slides.length > 1) {
        viewport.insertAdjacentElement('afterend', motionCue);
      }

      const syncControls = () => {
        const maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
        const atStart = viewport.scrollLeft <= 4;
        const atEnd = viewport.scrollLeft >= maxScroll - 4;

        if (previous) {
          previous.disabled = maxScroll <= 4 || atStart;
          previous.setAttribute('aria-disabled', previous.disabled ? 'true' : 'false');
        }

        if (next) {
          next.disabled = maxScroll <= 4 || atEnd;
          next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
        }

        syncActiveSlide();
      };

      const getScrollStep = () => {
        const slide = viewport.querySelector('.homepage-feature-carousel__slide');
        if (!slide) return Math.max(viewport.clientWidth * 0.82, 300);

        if (slides.length > 1) return slides[1].offsetLeft - slides[0].offsetLeft;
        return slide.offsetWidth;
      };

      const getCurrentIndex = () => {
        const step = getScrollStep();
        if (step <= 0) return 0;
        return Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / step)));
      };

      const restartDotProgress = () => {
        if (!dots.length) return;

        dots.forEach((dot) => {
          dot.classList.remove('is-timing');
        });

        if (!autoplayPaused && carouselInView && !prefersReducedMotion.matches) {
          window.requestAnimationFrame(() => {
            dots[activeIndex]?.classList.add('is-timing');
          });
        }
      };

      const syncActiveSlide = () => {
        const nextIndex = getCurrentIndex();
        if (nextIndex !== activeIndex) {
          activeIndex = nextIndex;
          restartDotProgress();
        }

        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === activeIndex);
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const scrollToIndex = (index) => {
        const safeIndex = Math.max(0, Math.min(slides.length - 1, index));
        viewport.scrollTo({ left: getScrollStep() * safeIndex, behavior: 'smooth' });
        window.setTimeout(syncControls, 380);
      };

      const clearAutoplay = () => {
        if (autoplayTimer) window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
        carousel.classList.remove('is-autoplaying');
        dots.forEach((dot) => dot.classList.remove('is-timing'));
      };

      const getAutoplayDelay = () => (hoverActive ? hoverAutoplayDelay : autoplayDelay);

      const scheduleAutoplay = (delay = getAutoplayDelay()) => {
        clearAutoplay();
        if (slides.length < 2 || autoplayPaused || !carouselInView || prefersReducedMotion.matches || document.hidden) return;

        carousel.style.setProperty('--feature-carousel-delay', `${delay}ms`);
        carousel.classList.add('is-autoplaying');
        restartDotProgress();
        autoplayTimer = window.setTimeout(() => {
          const destination = getCurrentIndex() >= slides.length - 1 ? 0 : getCurrentIndex() + 1;
          carousel.classList.add('is-rolling');
          scrollToIndex(destination);
          window.setTimeout(() => carousel.classList.remove('is-rolling'), 720);
          scheduleAutoplay();
        }, delay);
      };

      const pauseAutoplay = () => {
        autoplayPaused = true;
        clearAutoplay();
      };

      const resumeAutoplay = (delay = autoplayDelay) => {
        if (nativeTouchActive || pointerId !== null) return;
        autoplayPaused = false;
        syncControls();
        scheduleAutoplay(delay);
      };

      previous?.addEventListener('click', () => {
        pauseAutoplay();
        scrollToIndex(getCurrentIndex() - 1);
        window.setTimeout(() => resumeAutoplay(5200), 520);
      });

      next?.addEventListener('click', () => {
        pauseAutoplay();
        scrollToIndex(getCurrentIndex() + 1);
        window.setTimeout(() => resumeAutoplay(5200), 520);
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          pauseAutoplay();
          scrollToIndex(index);
          window.setTimeout(() => resumeAutoplay(5200), 520);
        });
      });

      let pointerId = null;
      let startX = 0;
      let startLeft = 0;
      let didDrag = false;

      const settleTouch = () => {
        window.clearTimeout(touchSettleTimer);
        if (touching) return;
        touchSettleTimer = window.setTimeout(() => {
          nativeTouchActive = false;
          resumeAutoplay(getAutoplayDelay());
        }, 240);
      };
      viewport.addEventListener('touchstart', () => {
        touching = true;
        nativeTouchActive = true;
        window.clearTimeout(touchSettleTimer);
        pauseAutoplay();
      }, { passive: true });
      const endTouch = (event) => {
        touching = event.touches.length > 0;
        settleTouch();
      };
      viewport.addEventListener('touchend', endTouch, { passive: true });
      viewport.addEventListener('touchcancel', endTouch, { passive: true });

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;
        if (event.target.closest(interactiveSelector)) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startLeft = viewport.scrollLeft;
        didDrag = false;
        pauseAutoplay();
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture?.(pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (Math.abs(distance) > 10) didDrag = true;
        viewport.scrollLeft = startLeft - distance;
      });

      const endDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        if (viewport.hasPointerCapture?.(pointerId)) viewport.releasePointerCapture(pointerId);
        pointerId = null;
        viewport.classList.remove('is-dragging');
        syncControls();
        window.setTimeout(() => {
          didDrag = false;
          resumeAutoplay();
        });
      };

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('pointerleave', endDrag);
      viewport.addEventListener('click', (event) => {
        if (!didDrag) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      carousel.addEventListener('mouseenter', () => {
        hoverActive = true;
        if (!autoplayPaused) scheduleAutoplay(hoverAutoplayDelay);
      });
      carousel.addEventListener('mouseleave', () => {
        hoverActive = false;
        if (!autoplayPaused) scheduleAutoplay(autoplayDelay);
      });
      carousel.addEventListener('focusin', pauseAutoplay);
      carousel.addEventListener('focusout', () => resumeAutoplay(getAutoplayDelay()));
      viewport.addEventListener('scroll', () => {
        syncControls();
        if (nativeTouchActive) settleTouch();
      }, { passive: true });
      window.addEventListener('resize', syncControls, { passive: true });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          carouselInView = entries[0]?.isIntersecting ?? true;
          if (carouselInView) {
            resumeAutoplay(1400);
          } else {
            clearAutoplay();
          }
        }, { threshold: 0.36 });
        observer.observe(carousel);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearAutoplay();
        } else {
          resumeAutoplay(1400);
        }
      });

      syncControls();
      scheduleAutoplay();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFeatureCarousels(), { once: true });
  } else {
    initFeatureCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => initFeatureCarousels(event.target));
})();

(() => {
  const initReviews = (root = document) => {
    root.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
      if (carousel.dataset.reviewReady) return;
      const track = carousel.querySelector('[data-review-track]');
      const cards = Array.from(track.children);
      if (cards.length < 2) return;
      carousel.dataset.reviewReady = 'true';
      const lifecycle = new AbortController();
      const options = { signal: lifecycle.signal };
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let hovering = false;
      let timer;
      let transitionTimer;
      let current = 0;
      let pointerStart;
      const schedule = () => {
        clearTimeout(timer);
        if (reducedMotion.matches || !visible || document.hidden || carousel.contains(document.activeElement)) return;
        timer = setTimeout(() => move(1), hovering ? 10000 : 5000);
      };
      const show = () => {
        cards.forEach((card, index) => {
          const active = index === current;
          card.classList.toggle('is-current', active);
          card.setAttribute('aria-hidden', String(!active));
          card.inert = !active;
        });
        schedule();
      };
      const move = (direction) => {
        clearTimeout(timer);
        clearTimeout(transitionTimer);
        cards[current].classList.remove('is-current');
        cards[current].setAttribute('aria-hidden', 'true');
        cards[current].inert = true;
        current = (current + direction + cards.length) % cards.length;
        transitionTimer = setTimeout(show, reducedMotion.matches ? 0 : 240);
      };
      track.addEventListener('pointerdown', (event) => {
        pointerStart = { x: event.clientX, y: event.clientY };
        clearTimeout(timer);
      }, options);
      track.addEventListener('pointerup', (event) => {
        if (!pointerStart) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1);
        else schedule();
      }, options);
      track.addEventListener('pointercancel', () => { pointerStart = null; schedule(); }, options);
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      carousel.addEventListener('pointerenter', () => { hovering = true; schedule(); }, options);
      carousel.addEventListener('pointerleave', () => { hovering = false; schedule(); }, options);
      carousel.addEventListener('focusin', () => clearTimeout(timer), options);
      carousel.addEventListener('focusout', () => requestAnimationFrame(schedule), options);
      document.addEventListener('visibilitychange', schedule, options);
      reducedMotion.addEventListener('change', schedule, options);
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        schedule();
      }, { threshold: 0.15 });
      observer.observe(carousel);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(carousel)) return;
        clearTimeout(timer);
        clearTimeout(transitionTimer);
        observer.disconnect();
        lifecycle.abort();
      }, options);
      show();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initReviews(), { once: true });
  else initReviews();
  document.addEventListener('shopify:section:load', (event) => initReviews(event.target));
})();
